import { useState, useEffect, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/pages/auth/components/AuthShell";
import { supabase } from "@/lib/supabase";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;
      // A recovery session is required; otherwise send back to login.
      if (!data.session) {
        navigate("/auth/login", { replace: true });
      } else {
        setChecking(false);
      }
    });
    return () => {
      active = false;
    };
  }, [navigate]);

  const handleReset = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (err) {
      setError("تعذر تحديث كلمة المرور، حاول مرة أخرى.");
    } else {
      navigate("/auth/login", { replace: true });
    }
  };

  const inputClass =
    "h-[52px] w-full rounded-[14px] border border-[#E4F5F5] bg-[#F0FDFD] px-4 text-sm text-ghasla-text-heading outline-none transition-colors focus:border-[#00AAB7]";

  if (checking) {
    return (
      <div dir="rtl" className="flex h-screen items-center justify-center bg-white">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#E4F5F5] border-t-[#0D6E6E]" />
      </div>
    );
  }

  return (
    <AuthShell title="تعيين كلمة مرور جديدة" subtitle="اختر كلمة مرور قوية لحسابك">
      <form onSubmit={handleReset} className="space-y-5">
        <div>
          <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">كلمة المرور الجديدة</label>
          <input
            type="password"
            className={inputClass}
            dir="ltr"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="8 أحرف على الأقل"
            minLength={8}
            required
            autoComplete="new-password"
          />
        </div>
        {error && <p className="text-sm font-medium text-[#E74C3C]">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="h-[52px] w-full cursor-pointer rounded-[14px] bg-gradient-to-l from-[#00AAB7] to-[#00C4CF] text-base font-bold text-white shadow-glow transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {loading ? "جارٍ الحفظ..." : "حفظ كلمة المرور"}
        </button>
      </form>
    </AuthShell>
  );
}